export const FEATURE_SUB_TITLE_LIGHTING = 'Lights';
export const FEATURE_SUB_TITLE_EXTERIOR = 'Exterior';
export const FEATURE_SUB_TITLE_INTERIOR = 'Interior';
export const FEATURE_SUB_TITLE_COMFORT_AND_CONVENIENCE = 'Comfort & Convenience'; // @suppress longLineCheck
export const FEATURE_SUB_TITLE_INFOTAINMENT_SYSTEM = 'Infotainment System';
export const FEATURE_SUB_TITLE_SAFETY_AND_LOCKS = 'Safety & Locks';
export const FEATURE_SUB_TITLE_BRAKES_AND_SUSPENSION = 'Brakes & Suspension';
export const FEATURE_SUB_TITLE_DRIVING_ASSISTANCE = 'Driving Assistance';
export const FEATURE_SUB_TITLE_ADDITIONAL_FEATURES = 'Additional Features';
export const FEATURE_SUB_TITLE_REMARKS = 'Remarks';
export const FEATURE_ITEM_TITLE_HEAD_LIGHTS = 'Head Lights';
export const FEATURE_ITEM_TITLE_DYNAMIC_RUNNING_LIGHTS = 'Daytime Running Lights'; // @suppress longLineCheck
export const FEATURE_ITEM_TITLE_AUTO_HEAD_LIGHTS = 'Auto Head Lights'; // @suppress longLineCheck
export const FEATURE_ITEM_TITLE_ELECTRICE_FOLDING_SIDE_MIRRORS = 'Electric Folding Side Mirrors'; // @suppress longLineCheck
export const FEATURE_ITEM_TITLE_RAIN_SENSING_WIPERS = 'Rain Sensing Wipers'; // @suppress longLineCheck
export const FEATURE_ITEM_TITLE_MULTI_FUNCTION_STEERING_WHEEL = 'Multi-function Steering Wheel'; // @suppress longLineCheck
export const FEATURE_ITEM_TITLE_PADDLE_SHIFTERS = 'Paddle Shifters';
export const FEATURE_ITEM_TITLE_KEYLESS_ENTRY = 'Keyless Entry';
export const FEATURE_ITEM_TITLE_KEYLESS_ENGINE_START = 'Keyless Engine Start'; // @suppress longLineCheck
export const FEATURE_ITEM_TITLE_MULTI_ZONE_AIRCON = 'Multi-zone Aircon';
export const FEATURE_ITEM_TITLE_REAR_AIRCON = 'Rear Aircon';
export const FEATURE_ITEM_TITLE_SEAT_UPHOLSTERY = 'Seat Upholstery';
export const FEATURE_ITEM_TITLE_SUNROOF = 'Sunroof/Moonroof/ Panoramic Roof'; // @suppress longLineCheck
export const FEATURE_ITEM_CAPTAIN_SEAT = 'Captain Seats (2nd Row)'; // @suppress longLineCheck
export const FEATURE_ITEM_FOLDING_TABLE = 'Folding Table (2nd Row)'; // @suppress longLineCheck
export const FEATURE_ITEM_DRIVERS_ELECTRIC_SEAT = 'Driver’s Electric Seat'; // @suppress longLineCheck
export const FEATURE_ITEM_PASSENGERS_ELECTRIC_SEAT = 'Passenger’s Electric Seat'; // @suppress longLineCheck
export const FEATURE_ITEM_VENTILATED_SEAT = 'Ventilated Seats';
export const FEATURE_ITEM_KNOCKDOWN_REAR_SEAT = 'Knockdown Rear Seats';
export const FEATURE_ITEM_ELECTRIC_TAILGATE = 'Electric Tailgate';
export const FEATURE_ITEM_ELECTRIC_SLIDING_DOOR = 'Electric Sliding Door';
export const FEATURE_ITEM_BLUETOOTH = 'Bluetooth';
export const FEATURE_ITEM_APPLE_CARPLAY = 'Apple CarPlay';
export const FEATURE_ITEM_ANDROID_AUTO = 'Android Auto';
export const FEATURE_ITEM_WIRELESS_SMARTPHONE_CHARGING = 'Wireless Smartphone Charging'; // @suppress longLineCheck
export const FEATURE_ITEM_NAVIGATION_SYSTEM = 'Navigation System';
export const FEATURE_ITEM_HEADS_UP_DISPLAY = 'Heads-Up Display';
export const FEATURE_ITEM_INFOYAINMENT = 'Infotainment';
export const FEATURE_ITEM_SOUND_SYSTEM = 'Sound System';
export const FEATURE_ITEM_NO_OF_AIRBAGS = 'No. of Airbags';
export const FEATURE_ITEM_ISOFIX = 'Isofix';
export const FEATURE_ITEM_TYRE_PRESSURE_MONITOR = 'Tyre Pressure Monitor';
export const FEATURE_ITEM_ELECTRIC_PARK_BRAKE = 'Electric Park Brake';
export const FEATURE_ITEM_HILL_START_ASSIST = 'Hill Start Assist';
export const FEATURE_ITEM_EMERGENCY_BRAKE_ASSIST = 'Emergency Brake Assist';
export const FEATURE_ITEM_PARKING_SENSORS = 'Parking Sensors';
export const FEATURE_ITEM_REVERSE_CAMERA = 'Reverse Camera';
export const FEATURE_ITEM_360_VIEW_CAMERA = '360° View Camera';
export const FEATURE_ITEM_PARK_ASSIST = 'Park Assist';
export const FEATURE_ITEM_CRUISE_CONTROL = 'Cruise Control';
export const FEATURE_ITEM_LANE_KEEP_ASSIST = 'Lane Keep Assist';
export const FEATURE_ITEM_LANE_DEPARTURE_WARNING = 'Lane Departure Warning';
export const FEATURE_ITEM_BLIND_SPOT_MONITOR = 'Blind Spot Monitor';
export const ICON_SIZE_IN_PIXEL = 18;
